import React, { useRef, useState } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { FaBell } from 'react-icons/fa6'

import ChatInfoAccordionItem from '../info-accordion-item'
import SharedStack from '~components/shared/wrappers/shared-stack'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'
import {
    eqBoolFilter,
    eqStringFilter,
    gteFloatFilter,
} from '~utils/query-helpers'
import {
    ChatFieldsFragment,
    useQueryPimsRemindersQuery,
} from '~graphql/generated/graphql'
import ClientReminderItem from './reminder-item'
import InfoLoadingPlaceholder from '../info-loading-placeholder'
import InfoEmptyPlaceholder from '../info-empty-placeholder'

interface Props {
    chat: ChatFieldsFragment
}

export default function ChatClientDetailsUpcomingReminders({ chat }: Props) {
    const todayRef = useRef(new Date())
    const { client, clinic } = chat

    const [isOpen, setIsOpen] = useState(false)

    const { data, loading } = useQueryPimsRemindersQuery({
        variables: {
            where: [
                eqStringFilter('clinic', clinic.id),
                eqStringFilter('client', client.id),
                eqBoolFilter('patient.is_active', true),
                eqBoolFilter('is_active', true),
                eqBoolFilter('is_completed', false),
                gteFloatFilter('send_date', todayRef.current.getTime()),
            ],
            page: 0,
            pageSize: 3,
            orderBy: {
                column: 'send_date',
                isAscending: true,
            },
        },
        skip: !clinic || !client || !isOpen,
    })

    const reminders = data?.queryPimsReminders || []

    return (
        <ChatInfoAccordionItem
            icon={FaBell}
            title="Upcoming Reminders"
            isOpenState={isOpen}
            setIsOpenState={setIsOpen}
        >
            <Box px={4} pt={2} pb={3}>
                <AsyncWrapper
                    loading={loading}
                    loadingComponent={<InfoLoadingPlaceholder />}
                    empty={reminders.length === 0}
                    emptyComponent={<InfoEmptyPlaceholder item="reminders" />}
                >
                    <SharedStack spacing={0}>
                        {reminders.map(reminder => (
                            <ClientReminderItem
                                key={reminder.id}
                                chat={chat}
                                reminder={reminder}
                            />
                        ))}
                    </SharedStack>
                </AsyncWrapper>
            </Box>
        </ChatInfoAccordionItem>
    )
}
